import { render, staticRenderFns } from "./protocol_component_protocol.vue?vue&type=template&id=1be32780"
import script from "./protocol_component_protocol.vue?vue&type=script&lang=js"
export * from "./protocol_component_protocol.vue?vue&type=script&lang=js"
import style0 from "./protocol_component_protocol.vue?vue&type=style&index=0&id=1be32780&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports